import type { SymbolKind } from './types';

/**
 * tree-sitter capture name -> outline kind. Each definition pattern tags its
 * top node with one `@def.*` capture (kind) and the identifier with `@name`.
 */
export const CAPTURE_KIND: Record<string, SymbolKind> = {
  'def.class': 'class',
  'def.interface': 'interface',
  'def.enum': 'enum',
  'def.type': 'type',
  'def.namespace': 'namespace',
  'def.function': 'function',
  'def.method': 'method',
};

/** Definitions query for the `javascript` grammar (js / jsx / mjs / cjs). */
export const JAVASCRIPT_QUERY = `
(class_declaration
  name: (identifier) @name) @def.class

(function_declaration
  name: (identifier) @name) @def.function

(generator_function_declaration
  name: (identifier) @name) @def.function

(method_definition
  name: (property_identifier) @name) @def.method

(variable_declarator
  name: (identifier) @name
  value: [(arrow_function) (function_expression)]) @def.function

(variable_declarator
  name: (identifier) @name
  value: (class)) @def.class
`;

/**
 * Definitions query for the `typescript` and `tsx` grammars. Superset of the JS
 * query plus TS-only node types. Class/interface/type names are `type_identifier`
 * in the TS grammar (not `identifier`).
 */
export const TYPESCRIPT_QUERY = `
(class_declaration
  name: (type_identifier) @name) @def.class

(abstract_class_declaration
  name: (type_identifier) @name) @def.class

(interface_declaration
  name: (type_identifier) @name) @def.interface

(enum_declaration
  name: (identifier) @name) @def.enum

(type_alias_declaration
  name: (type_identifier) @name) @def.type

(internal_module
  name: (identifier) @name) @def.namespace

(function_declaration
  name: (identifier) @name) @def.function

(function_signature
  name: (identifier) @name) @def.function

(method_definition
  name: (property_identifier) @name) @def.method

(method_signature
  name: (property_identifier) @name) @def.method

(abstract_method_signature
  name: (property_identifier) @name) @def.method

(variable_declarator
  name: (identifier) @name
  value: [(arrow_function) (function_expression)]) @def.function

(variable_declarator
  name: (identifier) @name
  value: (class)) @def.class
`;
